export default __webpack_public_path__ + "static/media/flag-tuvalu.92c1280a.svg";